import { withAppContext } from '@/config/site'
import request from '@/utils/request'

/**
 * 获取课程知识点树
 * @param {number} courseId - 课程ID
 * @param {object} payload - 其他参数
 * @returns {Promise<array>} 知识点树形结构
 */
export const fetchKnowledgeTree = async (courseId, payload = {}) => {
  const response = await request('/page/course/knowledge/tree', {
    data: withAppContext({
      course_id: courseId,
      ...payload
    })
  })

  return Array.isArray(response.data) ? response.data : []
}

/**
 * 获取课程知识图谱数据
 * @param {number} courseId - 课程ID
 * @param {object} payload - 其他参数
 * @returns {Promise<object>} 知识图谱数据（包含节点和边）
 */
export const fetchKnowledgeGraph = async (courseId, payload = {}) => {
  const response = await request('/page/course/knowledge/graph', {
    data: withAppContext({
      course_id: courseId,
      ...payload
    })
  })

  return response.data || { nodes: [], edges: [] }
}

/**
 * 获取目标关联的知识点列表
 * @param {number} targetType - 目标类型 1:章节 2:课时 3:教材 4:资源 5:内容块
 * @param {number} targetId - 目标ID
 * @param {object} payload - 其他参数
 * @returns {Promise<array>} 关联的知识点列表
 */
export const fetchKnowledgeByTarget = async (targetType, targetId, payload = {}) => {
  const response = await request('/page/course/knowledge/by-target', {
    data: withAppContext({
      target_type: targetType,
      target_id: targetId,
      ...payload
    })
  })

  return Array.isArray(response.data) ? response.data : []
}
